module.exports = __webpack_public_path__ + "static/media/6-2.5913ecd1.mp3";